export default __webpack_public_path__ + "static/ngpvan-13e0ab0449647b771ef387f830749e49.png";